import { createRouter, createWebHistory } from 'vue-router'
import TestCase from '../views/TestCase.vue'
import CouponList from '../views/CouponList.vue'
import CouponDetail from '../views/CouponDetail.vue'
import NoToken from '../views/NoToken.vue'
import MaintainPage from '../views/MaintainPage.vue'
import {CKey, SKey, writeToStorage} from '../js/storage.js';
import { createMaintenanceGate } from '../js/maintenance-gate.js';

const routes = [
  {
    path: '/TestCase',
    name: 'TestCase',
    component: TestCase
  },
  {
    path: '/MaintainPage',
    name: 'MaintainPage',
    component: MaintainPage,
    meta: { allowDuringMaintenance: true } 
  },
  {
    path: '/',
    name: 'index',
    component: NoToken
  },
  {
    path: '/Coupon/CouponList',
    name: 'CouponList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: CouponList
  },
  {
    path: '/Coupon/CouponDetail',
    name: 'CouponDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: CouponDetail
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// let apiUrl=process.env.VUE_APP_apiUrl ;
// let apiUrlReal="";

// if (apiUrl){
//     apiUrlReal=apiUrl +"/";
// }else{
//     apiUrlReal=window.location.protocol + "//"+ window.location.host + "/";
// }

// const gate = createMaintenanceGate(apiUrlReal+'CouponApiByT/getMaintainModeMessage');

// router.beforeEach(async (to, from, next) => {
//   debugger;
//   const allow = to.meta && to.meta.allowDuringMaintenance;
//   const { isMaint, message } = await gate.check(false);

//   if (isMaint && !allow && to.name !== 'MaintainPage') {
//     // 把維護訊息放在 query，一起帶去維護頁
//     next({ name: 'MaintainPage', query: {msg: message } });
//     // next({ name: 'MaintainPage', query: { r: to.fullPath, msg: message } });
//   } else {
//     // 如果當前路由是 'CouponMain'，則將 query string 存儲到 localStorage
//     if (to.path === '/Coupon/CouponMain' ) {
//       //if query have C
//       if(to.query[CKey] && to.query[SKey]) {
//         writeToStorage(CKey, to.query[CKey]);
//         next({path: '/Coupon/CouponDetail', query: {couponSID: to.query[SKey], mode: "list"}});
//       }else if (to.query[CKey]){
//         writeToStorage(CKey, to.query[CKey]);
//         next({ path: '/Coupon/CouponList' });
//       }else{
//           next({ path: '/' });
//       }
//     }else{
//       next();
//     }
//   }
// });
// 

let apiUrl=process.env.VUE_APP_apiUrl ;
let apiUrlReal="";

if (apiUrl){
    apiUrlReal=apiUrl +"/";
}else{
    apiUrlReal=window.location.protocol + "//"+ window.location.host + "/";
}

const gate = createMaintenanceGate(apiUrlReal+'CouponApiByT/getMaintainModeMessage');
router.beforeEach(async (to, from, next) => {
  // 只有當前路由是 CouponList 時，才檢查維護模式
  if (to.name === 'CouponList') {
    const allow = to.meta && to.meta.allowDuringMaintenance;
    const { isMaint, message } = await gate.check(false);

    if (isMaint && !allow && to.name !== 'MaintainPage') {
      // 把維護訊息放在 query，一起帶去維護頁
      next({ name: 'MaintainPage', query: {msg: message } });
      return;
    }
  }

  // 如果當前路由是 'CouponMain'，則將 query string 存儲到 localStorage
  if (to.path === '/Coupon/CouponMain' ) {
    //if query have C
    if(to.query[CKey] && to.query[SKey]) {
      writeToStorage(CKey, to.query[CKey]);
      next({path: '/Coupon/CouponDetail', query: {couponSID: to.query[SKey], mode: "list"}});
    }else if (to.query[CKey]){
      writeToStorage(CKey, to.query[CKey]);
      next({ path: '/Coupon/CouponList' });
    }else{
        next({ path: '/' });
    }
  }else{
    next();
  }
});




// router.beforeEach(async (to, from, next) => {
//   debugger;
//   const allow = to.meta && to.meta.allowDuringMaintenance;
//   const { isMaint, message } = await gate.check(false);

//   if (isMaint && !allow && to.name !== 'MaintainPage') {
//     // 把維護訊息放在 query，一起帶去維護頁
//     next({ name: 'MaintainPage', query: {msg: message } });
//     // next({ name: 'MaintainPage', query: { r: to.fullPath, msg: message } });
//   } else {
//     // 如果當前路由是 'CouponMain'，則將 query string 存儲到 localStorage
//     if (to.path === '/Coupon/CouponMain' ) {
//       //if query have C
//       if(to.query[CKey] && to.query[SKey]) {
//         writeToStorage(CKey, to.query[CKey]);
//         next({path: '/Coupon/CouponDetail', query: {couponSID: to.query[SKey], mode: "list"}});
//       }else if (to.query[CKey]){
//         writeToStorage(CKey, to.query[CKey]);
//         next({ path: '/Coupon/CouponList' });
//       }else{
//           next({ path: '/' });
//       }
//     }else{
//       next();
//     }
//   }
// });



// router.beforeEach((to, from, next) => {
//   debugger;
//     // 如果當前路由是 'CouponMain'，則將 query string 存儲到 localStorage
//     if (to.path === '/Coupon/CouponMain' ) {
//       //if query have C
//       if(to.query[CKey] && to.query[SKey]) {
//         writeToStorage(CKey, to.query[CKey]);
//         next({path: '/Coupon/CouponDetail', query: {couponSID: to.query[SKey], mode: "list"}});
//       }else if (to.query[CKey]){
//         writeToStorage(CKey, to.query[CKey]);
//         next({ path: '/Coupon/CouponList' });
//       }else{
//           next({ path: '/' });
//       }
//     }else{
//       next();
//     }
// });


export default router
